import { type FC } from "react";

import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import TableCellText from "./core/TableCellText.js";

const SpeciesCell: FC<IAgGridCellProps> = (props) => {
  return <TableCellText {...props} style={{ fontStyle: "italic" }} />;
};

export default SpeciesCell;
